// src/pages/subscription/PlanCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Plan creation now
// happens through PlanFormDialog (form-kit), opened from PlanListPage's
// "Create Plan" — see docs/ux/14-forms.md. This route just sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const PlanCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/subscriptions/plans', { replace: true });
  }, [navigate]);
  return null;
};

export default PlanCreatePage;
